<template>
  <div>
    <a-card :bordered="false">
      <!-- 查询表单 -->
      <a-form-model ref="searchForm" :model="searchForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 17, offset: 1 }">
        <a-row>
          <a-col :xs="24" :sm="24" :md="24" :lg="6" :xl="6" :xxl="6">
            <a-form-model-item label="咨询类型" prop="category">
              <a-input v-model="searchForm.category" placeholder="请输入咨询类型"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :xs="24" :sm="24" :md="24" :lg="6" :xl="6" :xxl="6"></a-col>
          <a-col :xs="24" :sm="24" :md="24" :lg="6" :xl="6" :xxl="6"></a-col>
          <a-col :xs="24" :sm="24" :md="24" :lg="6" :xl="6" :xxl="6">
            <a-space style="float: right">
              <a-button type="default" @click="resetSearchForm">重置</a-button>
              <a-button type="primary" @click="searchOk">查询</a-button>
            </a-space>
          </a-col>
        </a-row>
      </a-form-model>

      <!-- 列表 -->
      <a-table
        :columns="columns"
        :data-source="dataSource"
        :loading="dataLoading"
        :row-key="(record) => record.id"
        :pagination="pagination"
        @change="handleTableChange"
        :scroll="{ x:1440 }"
        :bordered="false"
      >
        <template slot="action" slot-scope="text,record">
          <a-space>
            <!-- <a-popconfirm title="确认删除该留言吗?" ok-text="确认" cancel-text="取消" @confirm="deleteRecord(record)">
              <a-button type="danger" icon="delete"></a-button>
            </a-popconfirm> -->
            <a @click="showDetail(record)">详情</a>
          </a-space>
        </template>
      </a-table>
    </a-card>


    <!-- 显示详情 -->
    <a-modal title="详情" :visible="detailVisible" :footer="null" @cancel="detailVisible=false" width="60%" centered>
      <a-skeleton :loading="skeletonLoading" active>
        <div>
          <p>姓名：{{detail.username}}</p>
          <p>咨询类型：{{detail.category}}</p>
          <p>邮箱：{{detail.email}}</p>
          <p>联系方式：{{detail.contact_information}}</p>
          <p>留言：{{detail.description}}</p>
          <p>创建时间：{{detail.created_at}}</p>
          <p>更新时间：{{detail.updated_at}}</p>
        </div>
      </a-skeleton>
    </a-modal>
  </div>
</template>

<script>
import { reqMessageList,reqMessageDetail } from "@/api/index";

const columns = [
  {
    title: "姓名",
    dataIndex: "username",
    align: "center",
    width: 210,
    ellipsis: true,
  },
  {
    title: "咨询类型",
    dataIndex: "category",
    align: "center",
    width: 210,
    ellipsis: true,
  },
  {
    title: "邮箱",
    dataIndex: "email",
    align: "center",
    width: 210,
    ellipsis: true,
  },
  {
    title: "联系方式",
    dataIndex: "contact_information",
    align: "center",
    width: 210,
    ellipsis: true,
  },
  {
    title: "留言",
    dataIndex: "description",
    align: "center",
    width: 400,
    ellipsis: true,
  },
  {
    title: "创建时间",
    dataIndex: "created_at",
    align: "center",
    width: 210,
    ellipsis: true,
  },
  {
    title: "操作",
    dataIndex: "action",
    align: "center",
    scopedSlots: { customRender: "action" },
    width: 210,
    ellipsis: true,
  },
];

export default {
  data() {
    return {
      columns,
      dataSource: [],
      dataLoading:false,
      pagination: {
        total:0,
        current: 1,
        pageSize: 10,
        showTotal: (total) => `当前共有${total}条数据`,
      },
      searchForm: {
        category: "",
      },
      detail:{},
      detailVisible:false,
      skeletonLoading:false
    };
  },
  mounted() {
    this.getMessageList();
  },
  methods: {
    // 获取留言列表
    async getMessageList(isSearch = false) {
      this.dataLoading = true
      const res = await reqMessageList({ limit: this.pagination.pageSize, page: this.pagination.current, ...this.searchForm });
      if (res.data.code === 1) {
        if (isSearch) this.$message.success(res.data.msg);
        this.dataSource = res.data.data.data || [];
        this.pagination.total = res.data.data.total;
        this.dataLoading = false
      } else {
        this.$message.error(res.data.msg);
      }
    },
    handleTableChange(pagination) {
      this.pagination = pagination;
      this.getMessageList();
    },
    // 删除留言
    deleteRecord(record) {
      //没有开发
    },
    //重置查询
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
    },
    //确认查询
    searchOk() {
      this.pagination.current = 1;
      this.getMessageList(true);
    },
    //查看详情
    async showDetail(record){
      this.detailVisible = true
      this.skeletonLoading = true
      const res = await reqMessageDetail({id:record.id})
      if(res.data.code == 1){
        this.detail = res.data.data
        this.skeletonLoading = false
      }else{
        this.$message.error(res.data.msg)
      }
    }
  },
}
</script>

<style lang="less" scoped>
</style>